import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Button } from "@/landing-page/components/button"
import Saxophone from "@/landing-page/components/icons/saxophone"
import Accordion from "@/landing-page/components/icons/accordion"
import Guitar2 from "@/landing-page/components/icons/guitar_2"
import Tambor from "@/landing-page/components/icons/tambor"
import { trackEvent } from "@/helpers/ga"

export function LookForTalent() {
  return (
    <section
      className="bg-red lg:py-16 py-10 relative z-0 overflow-hidden dark:bg-black dark:border-t"
      id="o-premio"
    >
      <StaticImage
        src="../images/bg_2_2.webp"
        alt="Imagem de Fundo 2"
        width={1920}
        height={1022}
        className="!absolute -top-1 left-0 -z-10 block w-full h-auto dark:hidden"
      />

      <div className="container flex flex-col items-center">
        <h2 className="font-serif text-sand text-center lg:text-7xl text-4xl lg:mb-5 mb-3">CONHEÇA TODOS OS PRÊMIOS</h2>

        <ul>
          <li className="relative bg-sand rounded-3xl py-12 lg:px-20 px-12 flex flex-col items-center mb-4">
            <h3 className="lg:text-3xl text-2xl text-center">
              Você vai receber R$10.000,00 para investir na sua preparação inicial: pode ser com figurino, preparação vocal, estúdio para ensaio, você escolhe!
            </h3>

            <Saxophone
              aria-label="Saxofone"
              className="absolute -left-14 top-2 transform lg:scale-75 scale-50 w-[120px] h-auto"
            />
          </li>
          <li className="relative bg-sand rounded-3xl py-12 lg:px-56 px-11 lg:pt-10 lg:pb-14 mb-4">
            <StaticImage
              src="../images/pretinho.webp"
              alt="Pretinho da Serrinha"
              width={872}
              height={676}
              className="!absolute bottom-0 lg:left-3 -left-8 block lg:w-72 w-28 h-auto dark:hidden z-0"
            />

            <h3 className="lg:text-3xl text-2xl text-center">
              Sua música vai ter direção musical de dois grandes nomes do mercado: Maria Gadú e Pretinho da Serrinha.
            </h3>

            <StaticImage
              src="../images/gadu.webp"
              alt="Maria Gadú"
              width={640}
              height={686}
              className="!absolute bottom-0 lg:right-2 -right-10 block lg:w-56 w-24 h-auto dark:hidden z-0"
            />
          </li>
          <li className="relative bg-sand rounded-3xl py-12 lg:px-20 px-12 mb-4">
            <h3 className="lg:text-3xl text-2xl text-center">
              Viagem com todas as despesas pagas para gravar o Feat dos Sonhos com seu ídolo, em um estúdio com toda estrutura profissional e uma equipe de produtores consagrados.
            </h3>

            <Accordion
              aria-label="Sanfona"
              className="absolute lg:-right-12 -right-6 lg:-top-6 -top-12 transform lg:scale-100 scale-50 w-32 h-auto"
            />
          </li>
          <li className="relative bg-sand rounded-3xl py-12 lg:px-20 px-12 mb-4">
            <h3 className="lg:text-3xl text-2xl text-center">
              Produção de um vídeo, sessão de fotos e produção de vários materiais para amplificar a divulgação da sua música.
            </h3>

            <Guitar2
              aria-label="Violão"
              className="absolute -left-14 lg:-top-24 -top-1/2 transform lg:scale-100 scale-50 w-[150px] h-auto"
            />
          </li>
          <li className="relative bg-sand rounded-3xl py-12 lg:px-24 px-12 mb-4">
            <h3 className="lg:text-3xl text-2xl text-center">
              Lançamento da sua música nas plataformas digitais, com suporte de uma agência de marketing digital e assessoria de imprensa.
            </h3>

            <Tambor
              aria-label="Tambor"
              className="absolute lg:-right-2 -right-10 -top-6 transform lg:scale-100 scale-50 w-[120px] h-auto"
            />
          </li>
        </ul>
      </div>
    </section>
  )
}
